import styled from "styled-components";

export const Row = styled.div<{
  $gap?: number;
  $center?: boolean;
  $full?: boolean;
  $wrap?: boolean;
  $spaceApart?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${({ $gap }) => $gap ?? 0}px;
  width: ${({ $center, $full }) => ($center || $full ? "100%" : "default")};
  flex-wrap: ${({ $wrap }) => ($wrap ? "wrap" : "default")};
  justify-content: ${({ $center, $spaceApart }) =>
    $center ? "center" : $spaceApart ? "space-between" : "flex-start"};
`;
